import React, { useMemo } from 'react';

import { Modal } from '@common/index';
import { CodeOutlined } from '@mui/icons-material';
import { Expression } from '@common/Expression';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<boolean>;
  inputState: {
    key: string;
    title: string;
    description?: string;
    options: string[];
    placeholder: string;
    value: string;
    setValue: (value: string) => void;
  };
}

export const ExpressionFullscreen: React.FC<Props> = ({ open, setOpen, inputState }) => {
  const { key, title, description, options, placeholder, value, setValue } = inputState;

  return (
    <Modal
      open={Boolean(open)}
      setOpen={setOpen}
      background='primary'
      header={title}
      identifier='Expression Editor'
      info={description}
      icon={<CodeOutlined />}
      noBottomBorder
      noPaddingBottom
      body={
        <Expression
          key={key}
          value={value}
          hideFullscreen
          minRows={16}
          maxRows={16}
          dataEdges={useMemo(() => [], [])}
          title={title}
          description={description}
          setValue={setValue}
          options={options}
          placeholder={placeholder}
        />
      }
    />
  );
};
